module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    ref: "container",
    staticClass: "reveal-text"
  }, [_c('span', [_vm._v(_vm._s(_vm.text))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d4003d8a"}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reveal-text/RevealText.vue
// module id = 451
// module chunks = 1